// extracted by mini-css-extract-plugin
export default {"categoryBasedListList":"style_categoryBasedListList__I-xEG","categoryBasedListLayout":"style_categoryBasedListLayout__78foD","categoryBasedList":"style_categoryBasedList__veD9x"};